import { api } from './client';

export interface AppSettingsDto {
  appName: string;
  iconFileId?: string | null;
  /** Глобальный выключатель функции 2FA (см. AdminPanel, вкладка «Настройки») — при false
   *  Настройки не показывают возможность её включить. */
  totpFeatureEnabled: boolean;
  /** Длительность показа одной сторис в просмотрщике (сек): фото и видео отдельно. */
  storyPhotoSeconds: number;
  storyVideoSeconds: number;
}

/** Публичный endpoint (без Bearer) — имя/иконка нужны ещё до логина. */
export function getAppSettings(): Promise<AppSettingsDto> {
  return api('/api/v1/settings');
}
